import { IBorderRadiusData, IFontData, IInteractiveElementColorData, IPagePrimaryElement, WidgetPlaceType } from "./index";
import { IAnimatedWidget } from "./widget-style-data";

export interface ISearchResultsWidgetData extends IPagePrimaryElement {
    readonly type: "SearchResultsWidget";
    placeType: WidgetPlaceType;
    id?: string | null;
    showSearchBox: boolean;
    searchBoxPlaceholder?: string | null;
    resultsPerPage: number;
    style: ISearchResultsWidgetStyle;
}

export interface ISearchResultsWidgetStyle extends IAnimatedWidget {
    font: IFontData;
    searchBoxStyle?: ISearchBoxWidgetStyle;
    resultsContentStyle: ISearchResultsContentWidgetStyle;
}

export interface ISearchBoxWidgetStyle {
    fillingColor: IInteractiveElementColorData;
    borderColor: IInteractiveElementColorData;
    textColor?: string | null;
    placeholderColor: IInteractiveElementColorData;
    iconsColor?: string | null;
    borderThickness?: string | null;
    radius?: IBorderRadiusData;
}

export interface ISearchResultsContentWidgetStyle {
    tabColor: IInteractiveElementColorData;
    resultMessageColor?: string | null;
    headingColor?: string | null;
    titleColor: IInteractiveElementColorData;
    textColor: IInteractiveElementColorData;
    paginationButtonColor: IInteractiveElementColorData;
}

export interface ISearchResultsWidgetRenderingData {
    showSearchBox: boolean;
    searchBoxPlaceholder?: string | null;
    resultsPerPage: number;
}

export abstract class SearchResultsWidgetData {

    public static get defaultData(): ISearchResultsWidgetData {
        return {
            type: "SearchResultsWidget",
            primaryElement: true,
            placeType: "Section",
            showSearchBox: true,
            searchBoxPlaceholder: "Search...",
            resultsPerPage: 5,
            style: this.defaultStyle
        };
    }

    public static get defaultStyle(): ISearchResultsWidgetStyle {
        return {
            font: {
                family: "Open Sans",
                weight: "400"
            },
            searchBoxStyle: {
                fillingColor: {
                    colorDefault: "#FFFFFF",
                    colorHovered: "#FFFFFF",
                },
                borderThickness: "1px",
                radius: {
                    topLeftPx: 0,
                    topRightPx: 0,
                    bottomLeftPx: 0,
                    bottomRightPx: 0
                },
                borderColor: {
                    colorDefault: "#C1C1C1",
                    colorHovered: "#C1C1C1"
                },
                textColor: "#3E3E3E",
                placeholderColor: {
                    colorDefault: "#C1C1C1",
                    colorHovered: "#C1C1C1"
                },
                iconsColor: "#7B828E"
            },
            resultsContentStyle: {
                tabColor: {
                    colorDefault: "#3E3E3E",
                    colorClicked: "#12A3F8"
                },
                resultMessageColor: "#3E3E3E",
                headingColor: "#3E3E3E",
                titleColor: {
                    colorDefault: "#3E3E3E",
                    colorHovered: "#3B507D"
                },
                textColor: {
                    colorDefault: "#3E3E3E",
                    colorHovered: "#3B507D"
                },
                paginationButtonColor: {
                    colorDefault: "#3B507D",
                    colorHovered: "#2F4063"
                }
            },
            animation: {
                animationSource: "site-design",
                animationData: {
                    name: "none",
                    duration: 1
                }
            }
        };
    }

    public static localScriptRerenderNeeded(leftHandSide?: ISearchResultsWidgetData, rightHandSide?: ISearchResultsWidgetData): boolean {
        return leftHandSide?.id === rightHandSide?.id &&
            leftHandSide?.showSearchBox === rightHandSide?.showSearchBox &&
            leftHandSide?.searchBoxPlaceholder === rightHandSide?.searchBoxPlaceholder &&
            leftHandSide?.resultsPerPage === rightHandSide?.resultsPerPage;
    }

}